import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AnalyticsHelpersService {
  getLast7DaysLabels(): string[] {
    const daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const labels: string[] = [];
    const today = new Date();
    today.setDate(today.getDate() - 1);
    for (let i = 6; i >= 0; i--) {
      const date = new Date(today);
      date.setDate(today.getDate() - i);
      labels.push(daysOfWeek[date.getDay()]);
    }
    return labels;
  }

  getDayOfWeekLabel(date: Date): string {
    const daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    return daysOfWeek[date.getDay()];
  }

  getMonthName(monthIndex: string | number): string {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const idx = typeof monthIndex === 'string' ? parseInt(monthIndex, 10) - 1 : monthIndex as number - 1;
    return months[idx];
  }

  getMonthsLabels(): string[] {
    const labels: string[] = [];
    const today = new Date();
    for (let i = 11; i >= 0; i--) {
      const month = new Date(today.getFullYear(), today.getMonth() - i, 1);
      labels.push(month.toLocaleDateString('en-US', { month: 'short' }));
    }
    return labels;
  }

  getLast30DaysLabels(): string[] {
    const labels: string[] = [];
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    for (let i = 29; i >= 0; i--) {
      const date = new Date(today);
      date.setDate(today.getDate() - i);
      labels.push(date.toISOString().split('T')[0]);
    }
    return labels;
  }

  getDisplayLabelsFor30Days(): string[] {
    const labels: string[] = [];
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    for (let i = 29; i >= 0; i--) {
      const date = new Date(today);
      date.setDate(today.getDate() - i);
      const day = date.getDate();
      const month = date.toLocaleDateString('en-US', { month: 'short' });
      labels.push(`${day} ${month}`);
    }
    return labels;
  }

  formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  getCustomDateRangeLabels(startDate: string, endDate: string): string[] {
    const labels: string[] = [];
    const start = new Date(startDate);
    const end = new Date(endDate);
    end.setDate(end.getDate() + 1);
    for (let date = new Date(start); date < end; date.setDate(date.getDate() + 1)) {
      labels.push(date.toISOString().split('T')[0]);
    }
    return labels;
  }

  formatDateRangeLabel(startDate: string, endDate: string): string {
    const start = new Date(startDate);
    const end = new Date(endDate);
    return `${start.toLocaleDateString('de-DE')} - ${end.toLocaleDateString('de-DE')}`;
  }
}


